import { dev } from '$app/environment';

export class ClientSettings {
	public static readonly SiteBaseUrl = this.assertSetting(
		import.meta.env.VITE_SITE_BASE_URL,
		'Site base URL'
	);

	public static readonly EnableSelectCommitsDialog =
		import.meta.env.VITE_ENABLE_SELECT_COMMITS === 'true';

	public static EnableApprovals = dev;

	public static DefaultMergeRequestSampleLink =
		'https://github.com/Dan1ve/vscode-svelte-component-extractor/pull/1';

	private static assertSetting(value: unknown, message: string) {
		if (dev) {
			return String(value ?? '');
		}
		if (!value) {
			console.error('Environment variable not set: ' + message);
		}
		return String(value ?? '');
	}
}
